<app-text-button (click)="onResetClick()" class="group">
  <div class="flex items-center gap-2 group-hover:text-blue">
    <mat-icon class="text-ml hvs-icon items-center group-hover:text-blue">
      settings_backup_restore
    </mat-icon>
    <span class="text-black group-hover:text-blue">
      {{ 'portal.courseSettings.reset' | transloco }}
    </span>
  </div>
</app-text-button>
